import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import { FlexCol, FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import { round } from '../../../utilities';

interface Props {
  discount: any;
  price: number | string;
  currency: string;
  unit: string;
  isActive: boolean;
  handleCountChange: (newValue: any) => void;
  isCart?: boolean;
}

function QuantityDiscount({
  discount,
  price,
  currency,
  unit,
  isActive,
  handleCountChange,
  isCart = false,
}: Props) {
  return (
    <QtyDiscountItem
      key={`${discount.minimal_amount}`}
      isActive={isActive}
      // tslint:disable-next-line:jsx-no-lambda
      onClick={() => handleCountChange(discount.minimal_amount)}
      isCart={isCart}
    >
      <QtyDiscountItemCount isCart={isCart}>
        {`${__('min.')} `}
        <QtyDiscountItemMinimalCount>
          {`${discount.minimal_amount} ${unit} `}
        </QtyDiscountItemMinimalCount>
        {`(-${discount.sale_percentage}%):`}
      </QtyDiscountItemCount>
      <QtyDiscountItemPercentage isCart={isCart}>
        <QtyDiscountItemPrice>{`${round(
          +price - (discount.sale_percentage / 100) * +price,
          2,
        )} ${currency}`}</QtyDiscountItemPrice>
        {` / ${unit}`}
      </QtyDiscountItemPercentage>
    </QtyDiscountItem>
  );
}

const QtyDiscountItem = styled.button<{ isActive?: boolean; isCart?: boolean }>`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  border: ${({ theme }) => theme.borders.secondary};
  border-color: ${({ theme, isActive }) =>
    isActive ? theme.colors.primary : '#cccccc'};
  color: ${({ theme }) => theme.colors.textPrimary};
  padding: ${({ isCart }) => (isCart ? rem(6) : rem(13))};
  background: white;
  box-shadow: ${({ theme }) => theme.boxShadow.input};
  cursor: pointer;

  &:hover {
    /* opacity: 0.8; */
    transition: border-color 0.2s ease-in;
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

const QtyDiscountItemCount = styled.div<{ isCart?: boolean }>`
  color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${({ isCart }) => (isCart ? rem(12) : rem(14))};
  font-weight: 400;
  margin-bottom: ${rem(8)};
`;

const QtyDiscountItemMinimalCount = styled.strong`
  color: ${({ theme }) => theme.colors.primary};
`;

const QtyDiscountItemPercentage = styled.div<{ isCart?: boolean }>`
  color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${({ isCart }) => (isCart ? rem(14) : rem(16))};
  /* margin-bottom: ${rem(8)}; */
`;

const QtyDiscountItemPrice = styled.span`
  color: ${({ theme }) => theme.colors.primary};
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(16)};
  font-weight: 700;
`;

export { QuantityDiscount };
